export class Template {
    emailTemplate = {};
    whatsAppTemplate = {};
    smsTemplate = {};
}